module.exports = __webpack_public_path__ + "img/construction_manager_button.a6374161.jpg";